export const SET_FINANCE_ACCOUNTS_LIST = 'SET_FINANCE_ACCOUNTS_LIST';
export const DISPLAY_ACCOUNT_NAME_MODAL = 'DISPLAY_ACCOUNT_NAME_MODAL';



// WEBPACK FOOTER //
// ./src/features/finance/accounts/constants.js